"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAV_TYPE_TOP = exports.NAV_TYPE_SIDE = exports.SIDE_NAV_DARK = exports.SIDE_NAV_LIGHT = exports.SIDE_NAV_COLLAPSED_WIDTH = exports.SIDE_NAV_WIDTH = exports.ROW_GUTTER = void 0;
var ROW_GUTTER = 16;
exports.ROW_GUTTER = ROW_GUTTER;
var SIDE_NAV_WIDTH = 250;
exports.SIDE_NAV_WIDTH = SIDE_NAV_WIDTH;
var SIDE_NAV_COLLAPSED_WIDTH = 80;
exports.SIDE_NAV_COLLAPSED_WIDTH = SIDE_NAV_COLLAPSED_WIDTH;
var SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
exports.SIDE_NAV_LIGHT = SIDE_NAV_LIGHT;
var SIDE_NAV_DARK = 'SIDE_NAV_DARK';
exports.SIDE_NAV_DARK = SIDE_NAV_DARK;
var NAV_TYPE_SIDE = 'SIDE';
exports.NAV_TYPE_SIDE = NAV_TYPE_SIDE;
var NAV_TYPE_TOP = 'TOP';
exports.NAV_TYPE_TOP = NAV_TYPE_TOP;